import React, { Component } from 'react';
import {withRouter} from "react-router";
import {connect} from "react-redux";
import * as pagesActions from "../../actions/pages";
import AuthService from '../../lib/AuthService';

class Login extends Component {
    constructor(props){
        super(props);
        this.state = {
            username: '',
            password: '',
            redirect: false,
            loginError : false

        };
        this.Auth = new AuthService();
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.forgotPassword = this.forgotPassword.bind(this);
    }

    handleInputChange(event) {

        this.setState({
            [event.target.name]: event.target.value
        });
    }
    componentDidMount() {
        fetch("config.json")
            .then(response => response.json())
            .then(data => {
                console.log(data);
                this.props.saveConfig(data);
            });

    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentWillMount() {

        if (this.Auth.loggedIn()) {
            this.props.history.replace('/vignets');
        }


    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.loggedinData.loggedin !== prevProps.loggedinData.loggedin && this.props.loggedinData.loggedin === true) {
                this.props.history.replace('/vignets');
        }
        if (this.props.loggedinData.login_error !== prevProps.loggedinData.login_error  && this.props.loggedinData.login_error === true) {

            this.setState({ loginError :true });
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        var userData = {username :this.state.username, password : this.state.password};
        console.log(userData);
        this.props.login(userData);
    }
    forgotPassword(){
        this.props.history.replace('/forgotpassword');
    }


    render() {
        console.log(this.props.pageSettingsData)
        let logo = require("../../assets/images/logo-black.png");
        return (
        <div class="wrapper">
            <section class="login-section">
                <div class="container">
                    <div class="main-holder">
                        <div class="login-panel">
                            <a href="./" class="logo-in">
                                <span class="logo-image-in">
                                    <img src={require('../../assets/images/Nuggets-logo.png')} width="200" alt="Nugget" />
                                </span>
                            </a>
                            <h1 class="main-head"></h1>
                            <form class="login-form" ref="form"
                        onSubmit = {this.handleSubmit}
                        onError={errors => console.log(errors)}>
                                <div class="form-input-all-holder">
                                    <div class="form-input-holder">
                                        <span class="icon-in icon-mail"></span>
                                            <input type="text" name="username" className="form-input" placeholder="Username" value={this.state.username} onChange={this.handleInputChange} required/>
                                    </div>
                                </div>

                                <div class="form-input-all-holder">
                                    <div class="form-input-holder">
                                        <span class="icon-in icon-key"></span>
                                        <input type="password" name="password" className="form-input" placeholder="Password" value={this.state.password}  onChange={this.handleInputChange} required />
                                        <a href="javascript:void(0);" class="icon-in icon-eye"></a>
                                    </div>
                                </div>
                                {this.state.loginError == true &&
                                <div className={'loginError'}>
                                    <h6>Please enter a valid username or password</h6>
                                </div>
                                }
                                <div class="form-input-all-holder">
                                    <label class="cs-checkbox">
                                        <input type="checkbox" class="cs-check-input" />
                                        <span class="input-overlay"></span>
                                        <label class="checkbox-text-in">Remember me</label>
                                    </label>
                                </div>

                                <div class="form-input-all-holder">
                                    <input type="submit" value="Login" class="form-submit" />
                                </div>

                                {/*<div class="form-input-all-holder text-center">*/}
                                {/*    <a href="javascript:void(0);" onClick={this.forgotPassword}  class="grey-anchor forgot-anchor">Forgot Password?</a>*/}
                                {/*</div>*/}
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        );
    }
}
function mapStateToProps(state) {
    return {
        loggedinData  :state.pages.userSettings,
        pageSettingsData  :state.pages.pageSettings
    };

}

export default  withRouter(connect(mapStateToProps, {
    login : pagesActions.checkLogin,
    saveConfig : pagesActions.saveConfig,
})(Login));


// WEBPACK FOOTER //
// ./src/components/login/Login.js